export default "__VITE_ASSET__DvSe4Jzt__"